import {Component, OnInit, ViewChild} from '@angular/core';
import {IOption} from "ng-select";
import {Location} from "@angular/common";
import {BsDatepickerConfig, BsModalRef} from "ngx-bootstrap";
import {BsModalService} from 'ngx-bootstrap/modal';
import {CorrectiveActionForwardAlmahComponent} from "../corrective-action-forward-almah/corrective-action-forward-almah.component";
import {HelperService} from "../services/helper.service";
import {LossPreventionAccessService} from "../services/loss-prevention-access.service";
import {RilrService} from "../services/rilr.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-findings-action-history-modal',
  templateUrl: './findings-action-history-modal.component.html',
  styleUrls: ['./findings-action-history-modal.component.scss'],
  providers: [RilrService, HelperService, LossPreventionAccessService],
})
export class FindingsActionHistoryModalComponent implements OnInit {

  public masterData: any = {};
  public employeeOption: Array<IOption> = [];
  public priorityArr: Array<IOption> = [];
  public departmentArr: Array<IOption> = [];
  public findingDeviationArr: Array<IOption> = [];
  public findingTypeArr: Array<IOption> = [];
  public actionAreaSelectionArr: Array<IOption> = [];
  public confirmDisabled: number = 0;
  public loggedUserData: any = {};
  colorTheme = 'theme-blue';
  bsConfig: Partial<BsDatepickerConfig>;
  isEdit: number;
  actionID: number;
  correctiveActionCommentsArr: any = [];
  correctiveActionHistoryArr: any = [];
  inspectedByChecklist: string = '';
  profilePic: string = 'profileImage/default.png';
  commentActionButton: boolean = true;
  actionCompleteClose: boolean = false;
  disabledEnterAccess: boolean = true;
  public allFindingAccess: boolean = true;
  public allActionAccess: boolean = true;
  public rootCauseAccess: boolean = true;
  public auditorOnlyCreateAccess: boolean = true;
  public findingCreateAccess: boolean = false;
  disabled: boolean = false;
  allWaysDisabled: boolean = false;
  public isDriverEmployee: number = 1;

  bsModalRefCorrectiveActionNewAl: BsModalRef;
  bsModalRefCAForwardAlMaha: BsModalRef;
  @ViewChild('swalModalSubmit') swalModalSubmit: any;
  @ViewChild('errorMessageHtml') errorMessageHtml: any;
  @ViewChild('swalModalActionClose') swalModalActionClose: any;
  public htmlErrorMessage: string = "";

  nextActionComment: any = {
    correctiveActionID: this.actionID,
    comment: "",
  };

  companySystemID = +this.helperService.getSelectedCompanyId();
  currentUserSystemID = +this.helperService.getuserID();
  lptAccessDisable: boolean = false;

  yesNoArr: any = [
    {value: 0, label: 'Open'},
    {value: 1, label: 'In Progress'},
    {value: 2, label: 'Closed'},
    {value: 3, label: 'Rejected'}
  ];

  public repeatedArr: any = [
    {value: 0, label: 'New'},
    {value: 1, label: 'Repeated'},
  ];

  constructor(public bsModalRef: BsModalRef,
              private modalService: BsModalService,
              private rilrService: RilrService,
              private location: Location,
              private spinner: NgxSpinnerService,
              private lossPreventionAccessService: LossPreventionAccessService,
              private helperService: HelperService) {
    this.bsConfig = Object.assign({}, {containerClass: this.colorTheme, dateInputFormat: 'DD/MM/YYYY'});
  }

  ngOnInit() {
    this.masterData.personResEmpSystemID = [this.masterData.personResEmpSystemID];
    setTimeout(() => {
      if (this.masterData.deviationID != 0) {
        this.isDriverEmployee = 1;
      } else {
        this.isDriverEmployee = 0;
      }
      this.getCorrectiveActionComments();
      this.getCorrectiveActionHistory();
      this.getAuditFindingAccess();
      this.getCorrectiveActionAccess(this.masterData.reportSystemID);
      //this.getEmployeeLptAccess();
      setTimeout(() => {
        this.getEmployeesEdit(this.masterData.personResEmpID);
        if (this.masterData.submitted === 2) {
          this.confirmDisabled = 1;
        }
        if ((this.masterData.actionAssignedTo == 1 && (this.masterData.personResEmpSystemID == this.currentUserSystemID)) || (this.masterData.actionAssignedTo == 2 && (this.masterData.departmentID == this.loggedUserData.empDepartment))) {
          this.rootCauseAccess = false;
        }
      }, 0);
      this.modalService.onHide.subscribe((reason: string, event) => {
        if (reason) {
          if (reason === 'corrective_action_forward') {
            this.getCorrectiveActionComments();
            this.getCorrectiveActionHistory();
            this.getActionForwardUser();
          }
        }
      });
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('corrective_action_edit_closed');
  }

  commentButtonAction() {
    this.commentActionButton = false;
  }

  cancelCorrectiveActionComment() {
    this.commentActionButton = true;
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  getCorrectiveActionComments() {
    const that = this;
    that.spinner.show();
    that.correctiveActionCommentsArr = [];
    that.rilrService
      .getCorrectiveActionComments()
      .get({'actionID': that.actionID})
      .subscribe(resp => {
        that.correctiveActionCommentsArr = resp.data.data;
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
      });
  }

  getCorrectiveActionHistory() {
    const that = this;
    that.correctiveActionHistoryArr = [];
    that.rilrService
      .getCorrectiveActionHistory()
      .get({'actionID': that.actionID})
      .subscribe(resp => {
        that.correctiveActionHistoryArr = resp.data.data;
      }, (error) => {

      });
  }

  addCorrectiveActionComment() {
    const that = this;
    if (that.nextActionComment.comment != '') {
      that.spinner.show();
      that.nextActionComment.correctiveActionID = that.actionID;
      that.nextActionComment.host = window.location.origin;
      that.rilrService
        .reportCorrectiveActionCommentsCRUD()
        .post(that.nextActionComment)
        .subscribe(resp => {
          that.nextActionComment.comment = null;
          that.cancelCorrectiveActionComment();
          that.getCorrectiveActionComments();
          that.getCorrectiveActionHistory();
          that.spinner.hide();
        }, (error) => {
          that.spinner.hide();
        });
    }

  }

  public typehead(value: any): void {
    let that = this;
    if (value.length > 2) {
      that.getEmployees(value);
    } else {
      that.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': that.companySystemID
      })
      .subscribe(resp => {
        var tempOption = resp.data.data;
        that.employeeOption = [];
        that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, "employeeSystemID", "empName", "countryName", "description");
      }, (err) => {
        console.log(err);
        that.employeeOption = [];
      });
  }

  getEmployeesEdit(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        'search': value,
        'companySystemID': that.companySystemID
      })
      .subscribe(resp => {
        var tempOption = resp.data.data;
        that.employeeOption = [];
        that.employeeOption = that.helperService.setSelect2DropDownOptionsConcatLabelThree(tempOption, "employeeSystemID", "empName", "countryName", "description");
        setTimeout(() => {
          that.masterData.personResEmpSystemID = that.helperService.setSelectedValue(that.masterData.personResEmpSystemID);
        }, 0);

      }, (err) => {
        console.log(err);
        that.employeeOption = [];
      });
  }

  openCloseModal(field) {
    if (this.masterData.submitted && this.masterData.submitted === 2) {
      this.swalModalActionClose.show();
    } else {
      this.updateCorrectiveAction(field);
    }
  }

  cancelConfirmModel() {
    this.masterData.submitted = this.helperService.setSelectedValue(1);
  }

  public updateCorrectiveAction(field) {
    const that = this;
    that.spinner.show();
    that.masterData.targetDate = that.helperService.transformDate(that.masterData.targetDate);
    that.masterData.expectedCompletionDate = that.helperService.transformDate(that.masterData.expectedCompletionDate);
    that.masterData.host = window.location.origin;
    that.masterData.field = field;
    that.masterData.companySystemID = that.companySystemID;
    that.rilrService
      .reportFindingActionAlMahaUD()
      .post(that.masterData)
      .subscribe(resp => {
        that.getCorrectiveActionHistory();
        that.spinner.hide();
      }, (error) => {
        that.htmlErrorMessage = "";
        that.htmlErrorMessage = error.data.message;
        that.showErrorHtml();
        that.masterData.submitted = this.helperService.setSelectedValue(1);
        that.spinner.hide();
      });

  }

  public submitAssignedFinding() {
    const that = this;
    that.spinner.show();
    //that.masterData.field = field;
    that.masterData.companySystemID = that.companySystemID;
    that.rilrService
      .reportFindingAlMahaUD()
      .post(that.masterData)
      .subscribe(resp => {
        that.closeModal();
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
        that.htmlErrorMessage = '';
        if (error.status == 500) {
          that.htmlErrorMessage = error.data.message;
          that.showErrorHtml();
        } else if (error.status == 422) {
          that.htmlErrorMessage = that.helperService.serverSideError422(error.data.message);
          that.showErrorHtml();
        }
        this.masterData.findingSubmitted = 0;
      });

  }

  correctiveActionReAssign() {
    const that = this;
    that.bsModalRefCAForwardAlMaha = that.modalService.show(CorrectiveActionForwardAlmahComponent, {
      class: 'modal-md',
      backdrop: 'static'
    });
    that.bsModalRefCAForwardAlMaha.content.masterDataNew.actionAssignedTo = that.masterData.actionAssignedTo;
    that.bsModalRefCAForwardAlMaha.content.masterDataNew.actionID = that.masterData.actionID;
    that.bsModalRefCAForwardAlMaha.content.masterDataNew.personResEmpID = that.masterData.personResEmpID;
    that.bsModalRefCAForwardAlMaha.content.masterDataNew.personResEmpSystemID = that.masterData.personResEmpSystemID;
    that.bsModalRefCAForwardAlMaha.content.departmentArr = that.departmentArr;
    that.bsModalRefCAForwardAlMaha.content.masterDataNew.actionAssignedTo = that.helperService.setSelectedValue(that.masterData.actionAssignedTo);
    that.bsModalRefCAForwardAlMaha.content.masterDataNew.departmentID = that.helperService.setSelectedValue(that.masterData.departmentID);
    that.disabledEnterAccess = false;
  }

  getEmployeeLptAccess() {
    const that = this;
    that.lossPreventionAccessService
      .getCorrectiveActionLptAccess()
      .get({
        'actionID': that.actionID,
        'companySystemID': that.companySystemID
      })
      .subscribe(resp => {
        const temp = resp.data.data;
        if (temp.permission) {
          that.lptAccessDisable = true;
          that.disabled = false;
        } else {
          that.disabled = true;
        }
      }, (err) => {
      });
  }

  getActionForwardUser() {
    const that = this;
    that.rilrService
      .getActionForwardUpdatedUser()
      .get({'actionID': that.actionID})
      .subscribe(resp => {
        const temp = resp.data.data;
        that.masterData.actionAssignedTo = temp.actionAssignedTo;
        that.masterData.personResEmpID = temp.personResEmpID;
        that.masterData.personResEmpSystemID = temp.personResEmpSystemID;
        this.masterData.personResEmpSystemID = [this.masterData.personResEmpSystemID];
        this.masterData.departmentID = [this.masterData.departmentID];
        that.masterData.departmentID = that.helperService.setSelectedValue(temp.departmentID);
        that.getEmployeesEdit(temp.personResEmpID);
      }, (error) => {

      });
  }

  public getAuditFindingAccess() {
    const that = this;
    that.rilrService
      .getAuditFindingAccess()
      .get({
        'actionID': that.actionID,
      })
      .subscribe(resp => {
        const allAccess = resp.data.data.all_access;
        const actionAccess = resp.data.data.action_access;
        const tempActionCreator = resp.data.data.action_create_access;
        if (allAccess === "yes_all_access") {
          that.allFindingAccess = false;
        }
        if (actionAccess === "yes_action_access") {
          that.allActionAccess = false;
        }
        if (tempActionCreator === "yes_action_created_access") {
          that.findingCreateAccess = true;
        }
      }, (error) => {
      });
  }

  public findingUserSubmit() {
    this.swalModalSubmit.show();
    this.masterData.findingSubmitted = 1;
  }

  public findingUserCancel() {
    this.masterData.findingSubmitted = 0;
  }

  public getCorrectiveActionAccess(reportSystemID) {
    const that = this;
    that.auditorOnlyCreateAccess = true;
    that.rilrService
      .getCorrectiveActionCreateAccess()
      .get({
        'reportSystemID': reportSystemID,
      })
      .subscribe(resp => {
        const temp_auditor = resp.data.data.auditor_access;
        const temp_creater = resp.data.data.create_access;
        if (temp_auditor === "yes_access" || temp_creater === "yes_access") {
          that.auditorOnlyCreateAccess = false;
        }
      }, (error) => {
      });
  }

  public toggleDriver() {
    if (this.isDriverEmployee) {
      this.isDriverEmployee = 0;
      this.masterData.deviationID = 0;
    } else {
      this.isDriverEmployee = 1;
      this.masterData.deviation = '';
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/findings-action-history-modal/findings-action-history-modal.component.ts